import ReactDOM from 'react-dom/client'
import App from './App.tsx'
import './index.css'

// StrictMode disabled temporarily to prevent camera flickering in dev
// TODO: Re-enable after fixing double-mount issues
ReactDOM.createRoot(document.getElementById('root')!).render(
  <App />
)
